import React, { useEffect, useMemo, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Button,
} from "reactstrap"

import { Link, useNavigate, useParams } from "react-router-dom"
import leftArrow from "../../assets/images/icons/left-arrow.svg"
import {
  useApproveKYCSubmissionMutation,
  useLazyGetInvestorQuery,
  useRaiseQueryKYCMutation,
  useRejectKYCSubmissionMutation,
} from "store/api/investors/investors.api"
import IndividualView from "./individualView"
import NonIndividualView from "./nonIndividualView"
import KycRejectConfirmationModal from "./confirm/kycRejectConfirmation"
import KycApproveConfirmationModal from "./confirm/kycApproveConfirmation"
import { getInvestorsStatus } from "helpers/common"
import KycRaiseQuery from "./confirm/kycRaiseQuery"
import RaisedQueries from "./raisedQueries"

const ViewInvestor = () => {
  const { id } = useParams()
  const history = useNavigate()
  const [getResult, { isFetching }] = useLazyGetInvestorQuery()
  const [investorData, setInvestorData] = useState(null)
  const [raiseQuery, setRaiseQuery] = useState(false)
  const [isToast, setIsToast] = useState(false)
  const [actionType, setActionType] = useState() //APPROVE,REJECT

  const [onApprove, { isLoading: isApproving }] =
    useApproveKYCSubmissionMutation()
  const [onReject, { isLoading: isRejecting }] =
    useRejectKYCSubmissionMutation()
  const [onRaise, { isLoading: isRaising }] = useRaiseQueryKYCMutation()

  useEffect(() => {
    if (investorData) {
      if (investorData.status === "LINK_SENT") {
        history(`/investors/invite/${id}`)
      }
    }
  }, [investorData])

  useEffect(() => {
    if (id) {
      getInvestorData()
    }
  }, [id])

  const getInvestorData = async () => {
    const { data } = await getResult({ id }).unwrap()
    setInvestorData(data)
  }

  document.title = "Investor Details  | Prachay"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <div className="d-flex align-items-center gap-2 mb-4 pt-4">
            <Link to={"/investors"}>
              <img src={leftArrow} alt="" />
            </Link>
            <div className="page-title-name">Investor Details</div>
          </div>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody className="pt-4">
                  <div className="d-flex align-items-center mb-4 justify-content-between">
                    <CardTitle className="">
                      {investorData && investorData.entity_type === "INDIVIDUAL"
                        ? "Personal Details"
                        : "Entity Details"}
                    </CardTitle>
                    {investorData && (
                      <div className="code-status">
                        {getInvestorsStatus(
                          investorData?.status,
                          investorData.deleted_at
                        )}
                      </div>
                    )}
                  </div>
                  {investorData &&
                    investorData.entity_type === "INDIVIDUAL" && (
                      <IndividualView investorData={investorData} />
                    )}
                  {investorData && investorData.entity_type === "COMPANY" && (
                    <NonIndividualView investorData={investorData} />
                  )}
                </CardBody>
              </Card>
              {investorData?.kycRaisedQueries.length > 0 && (
                <Card>
                  <CardBody className="pt-4">
                    <div className="d-flex align-items-center mb-4 justify-content-between">
                      <CardTitle className="">Raised Queries</CardTitle>
                    </div>
                    <RaisedQueries
                      investorData={investorData}
                      data={investorData?.kycRaisedQueries}
                    />
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>

          <Row>
            <Col xl={12}>
              {investorData?.kyc_status === "SUBMITTED" &&
                investorData?.status === "UNDER_REVIEW" && (
                  <>
                    <div className="buttons button-wrapper buttons">
                      <button
                        className="btn cancel"
                        style={{
                          color: "#035CA1",
                          borderColor: "#035CA1",
                          minWidth: "200px",
                        }}
                        onClick={() => {
                          setRaiseQuery(true)
                        }}
                      >
                        Raise Query
                      </button>
                      {/* <Button
                        className="reject"
                        onClick={() => {
                          setIsToast(true)
                          setActionType("REJECT")
                        }}
                      >
                        Reject
                      </Button> */}
                      <Button
                        className="approve"
                        onClick={() => {
                          setIsToast(true)
                          setActionType("APPROVE")
                        }}
                      >
                        Approve
                      </Button>
                    </div>

                    {investorData && isToast && actionType === "APPROVE" && (
                      <KycApproveConfirmationModal
                        open={isToast}
                        id={investorData.id}
                        setOpen={setIsToast}
                        isLoading={isApproving}
                        onClose={() => {
                          setIsToast(false)
                          setActionType("")
                        }}
                        onApprove={onApprove}
                        onSuccess={getInvestorData}
                      />
                    )}

                    {investorData && isToast && actionType === "REJECT" && (
                      <KycRejectConfirmationModal
                        open={isToast}
                        id={investorData.id}
                        setOpen={setIsToast}
                        isLoading={isRejecting}
                        onClose={() => {
                          setIsToast(false)
                          setActionType("")
                        }}
                        onReject={onReject}
                        onSuccess={getInvestorData}
                      />
                    )}

                    {investorData && raiseQuery && (
                      <KycRaiseQuery
                        open={raiseQuery}
                        id={investorData.id}
                        investorData={investorData}
                        setOpen={setRaiseQuery}
                        isLoading={isRaising}
                        onClose={() => {
                          setRaiseQuery(false)
                        }}
                        onSubmit={onRaise}
                        onSuccess={getInvestorData}
                      />
                    )}
                  </>
                )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ViewInvestor
